import { CLEAR_GET_URL } from '../../actionTypes';

export default () => async (dispatch) => {
  dispatch({ type: CLEAR_GET_URL });
};
